<div *ngIf="!showEditAlert" id="showMessageId" style="display: block;">
  <div class="card card-nc  ">
    <div class="card-heading">
      <span class="icon-NC_alert"></span>
      <span class="cardHeaderHeading">{{ title }}</span>
      <span class="pull-right save-card">
        <button
          *ngIf="hasEntitlement('ALERT_UPDATE')"
          class="btn btn-nc-warning "
          style="background-color: C1554E;font-size: 8pt "
          (click)="editAlertMeaasge()"
        >
          UPDATE ALERT
        </button>
      </span>
    </div>
    <div class="card-body">
      <!-- Button trigger modal -->

      <div id="alert">
        <p class="text-justify" style="white-space: pre-line">
          <span class="ncAlertMessage1">{{ detail }}</span>
        </p>
      </div>
    </div>
  </div>
</div>

<div *ngIf="showEditAlert" id="EditMessageId">
  <form name="editAlert">
    <div class="card card-nc">
      <div class="card-heading">
        <div class="row">
          <div class="col-md-12">
            <span class="cardHeaderHeading"> UPDATE ALERT</span>
            <div class="float-right save-card-with-cancel ">
              <button
                [disabled]="
                  (!titleField.dirty && !detailField.dirty) ||
                  (titleField.invalid || detailField.invalid)
                "
                type="button"
                class="btn btn-nc saveBtnAlinRight"
                (click)="setAlertData()"
              >
                SAVE
              </button>
              <button
                type="button"
                class="btn cancel-btn "
                (click)="closeAndResetEditAlert()"
              >
                CANCEL
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="form-group">
          <input
            type="text"
            [class.has-error]="
              titleField.invalid && (titleField.dirty || titleField.touched)
            "
            class="form-control"
            id="title"
            name="title"
            placeholder="Alert Title"
            [(ngModel)]="title"
            #titleField="ngModel"
            required
          />
          <br />
          <span
            *ngIf="
              titleField.invalid && (titleField.dirty || titleField.touched)
            "
            class="help-block has-error validationMessage"
            >Required</span
          >
        </div>
        <div class="form-group">
          <textarea
            [class.has-error]="
              detailField.invalid && (detailField.dirty || detailField.touched)
            "
            class="form-control"
            rows="10"
            id="alertDetail"
            name="alertDetail"
            placeholder="Alert Content"
            style="max-width: 100%; min-width: 100%;"
            [(ngModel)]="detail"
            #detailField="ngModel"
            required
          ></textarea>
          <br />
          <span
            *ngIf="
              detailField.invalid && (detailField.dirty || detailField.touched)
            "
            class="help-block has-error validationMessage"
            >Required</span
          >
        </div>
      </div>
    </div>
  </form>
</div>
